import QuoteFormWrapper from "../../../../shared/components/quoteFormWrapper";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import { assetsPath } from "../../../../shared/utils/assetsPath";
import SupportStep from "../../enums/SupportStep";

const StepNavDisplay = () => {
  const selectedOptions =
    useAppStateStore((state) => state.selectedOptions) || [];
  const spCurrentStep = useAppStateStore((state) => state.spCurrentStep);
  const safeOptions = Array.isArray(selectedOptions) ? selectedOptions : [];

  return (
    <>
      {/* for the mobile view */}

      <div className="mobile-view margin-bottom-20">
        <QuoteFormWrapper>
          <h3 className="nav-header">Your Selected Changes</h3>
          {safeOptions.length > 0 ? (
            <div className="selectedOptionsContainer">
              {safeOptions.map((option, index) => {
                const isCurrentStep = option.id === spCurrentStep;
                const isPreviousStep =
                  safeOptions.findIndex((o) => o.id === option.id) <
                  safeOptions.findIndex((o) => o.id === spCurrentStep);
                return (
                  <div
                    className={`selectedOptionsDiv ${
                      isCurrentStep || isPreviousStep ? "currentOptionsDiv" : ""
                    }`}
                    key={option.id}
                  >
                    <div
                      className={`selectedOptionNumbering ${
                        isCurrentStep || isPreviousStep
                          ? "currentNumbering"
                          : ""
                      }`}
                    >
                      {isPreviousStep ||
                      spCurrentStep === SupportStep.SP_COMPLETE ? (
                        <img
                          className="step-white-tick"
                          src={assetsPath.whiteTick}
                          alt="tick"
                        />
                      ) : (
                        <h5>{index + 1}</h5>
                      )}
                      {index !== safeOptions.length - 1 && (
                        <div
                          className={`optionLine ${
                            isPreviousStep ? "optionLineCompleted" : ""
                          }`}
                        ></div>
                      )}
                    </div>
                    <h5
                      className={`${
                        isCurrentStep || isPreviousStep
                          ? "currentOptionTitle"
                          : "selectedOptionTitle"
                      }`}
                    >
                      {option.title}
                    </h5>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="gray-text">No options selected</p>
          )}
        </QuoteFormWrapper>
      </div>

      {/* for the Desktop view */}
      <div className="step-form-nav desktop-view">
        <div className="nav-num-container">
          <h3 className="nav-header">Your Selected Changes</h3>
          {safeOptions.length > 0 ? (
            <div className="selectedOptionsContainer">
              {safeOptions.map((option, index) => {
                const isCurrentStep = option.id === spCurrentStep;
                const isPreviousStep =
                  safeOptions.findIndex((o) => o.id === option.id) <
                  safeOptions.findIndex((o) => o.id === spCurrentStep);
                return (
                  <div
                    className={`selectedOptionsDiv ${
                      isCurrentStep || isPreviousStep ? "currentOptionsDiv" : ""
                    }`}
                    key={option.id}
                  >
                    <div
                      className={`selectedOptionNumbering ${
                        isCurrentStep || isPreviousStep
                          ? "currentNumbering"
                          : ""
                      }`}
                    >
                      {isPreviousStep ||
                      spCurrentStep === SupportStep.SP_COMPLETE ? (
                        <img
                          className="step-white-tick"
                          src={assetsPath.whiteTick}
                          alt="tick"
                        />
                      ) : (
                        <h5>{index + 1}</h5>
                      )}
                      {index !== safeOptions.length - 1 && (
                        <div
                          className={`optionLine ${
                            isPreviousStep ? "optionLineCompleted" : ""
                          }`}
                        ></div>
                      )}
                    </div>
                    <h5
                      className={
                        isCurrentStep
                          ? "currentOptionTitle"
                          : "selectedOptionTitle"
                      }
                    >
                      {option.title}
                    </h5>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="gray-text">No options selected</p>
          )}
        </div>
      </div>
    </>
  );
};

export default StepNavDisplay;
